app.controller("AddLanguageContainer", ["$scope", "StaticData", "$uibModalInstance", "Language",
    function ($scope, StaticData, $uibModalInstance, Language) {
        $scope.container = {
            name: "",
            required: 0
        };

        StaticData.getItemsByKey("container_types").then(function (types) {
            $scope.types = types;
        });

        $scope.create = function () {
            Language.createContainer($scope.container).then(function () {
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);